import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { placeholderProducts } from "../../CommonMethods";
import ProductContainer from "./ProductContainer";
import axios from "axios";

const Featured = () => {
  const [featuredItems, setFeaturedItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchFeatured() {
      setLoading(true);

      await axios
        .get(`${process.env.REACT_APP_API_URL}/filter/?featured=1`)
        .catch((_) => {})
        .then((response) => {
          if (response && response.status === 200) {
            setFeaturedItems(response.data);
          }
        });
      setLoading(false);
    }

    fetchFeatured();
  }, []);

  return loading ? (
    <div className="featured_products">
      <Container>
        <Row>
          <Col sm={3} className="featured_header">
            <h5> Featured</h5>
            <h3>Best New Deals</h3>
            <p>Upto 20% Off</p>
            <p>Shop Now While Stock Lasts</p>
          </Col>
          <Col sm={9} className="featured_content">
            {placeholderProducts(3)}
          </Col>
        </Row>
      </Container>
    </div>
  ) : (
    featuredItems.length > 0 && (
      <div className="featured_products">
        <Container>
          <Row>
            <Col sm={3} className="featured_header">
              <h5> Featured</h5>
              <h3>Best New Deals</h3>
              <p>Upto 20% Off</p>
              <p>Shop Now While Stock Lasts</p>
            </Col>
            <Col sm={9} className="featured_content">
              {/* added the .slice bcuz i changed the db to return 15 products to suit popular display  */}
              {featuredItems.slice(0, 5).map((element, index) => {
                return (
                  <ProductContainer
                    key={index}
                    product={element}
                    showBtn={true}
                  />
                );
              })}
            </Col>
          </Row>
        </Container>
      </div>
    )
  );
};

export default Featured;
